import CommonStyles from "./common.module.scss";
import { ImageBadgeNamePropsType } from "./types";
import { getFirstTwoInitialsOfName } from "./utils";
import { ROOT_REDUCER_ACTIONS, store } from "../store/store";
import { ReactNode, useState } from "react";
import { LOCAL_STORAGE_KEYS } from "./constants";
import Skeleton from "react-loading-skeleton";

export function ImageBadgeName({
  name,
  url,
  height = "32px",
  width = "32px",
  fontSize = "15px",
  margin = "",
  loading = false,
}: ImageBadgeNamePropsType) {
  const userData = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_KEYS.USER_META_DATA) || "{}"
  );
  const nameInitials = getFirstTwoInitialsOfName(name || userData?.given_name);
  const imgUrl = url || userData?.picture;
  const [error, setIsError] = useState();

  const initials = (
    <span className={CommonStyles.name} style={{ fontSize: fontSize }}>
      {nameInitials}
    </span>
  );

  return (
    <div
      className={CommonStyles.imgBadge}
      style={{
        height: height,
        width: width,
        margin: margin,
      }}
    >
      {loading ? (
        <Skeleton
          width={width}
          height={height}
          borderRadius="50%"
          style={{ borderWidth: "3px" }}
        />
      ) : imgUrl && !error ? (
        <img
          src={imgUrl}
          alt="profile"
          onError={(err: any) => {
            setIsError(err);
          }}
          height={height}
          width={width}
          style={{ borderRadius: "50%" }}
        />
      ) : (
        initials
      )}
    </div>
  );
}

export function logout() {
  store.dispatch({ type: ROOT_REDUCER_ACTIONS.LOGOUT });
}

export const RenderComponent = (Comp: any, data: any, props: {}): ReactNode => {
  return <Comp {...props} />;
};
